import { COLOR } from 'app-v2/design-tokens'
import { Icon } from 'app-v2/shared/features/icon'
import { Checkbox } from 'app/common/forms'
import { Text } from 'app/common/typography'
import React from 'react'
import styled from 'styled-components'

type Props = {
    code?: string,
    name: string,
    checked: boolean,
    updateFilters: () => void
}

export const Filter = ({ code, name, checked, updateFilters }: Props) => {
    return (
        <StyledLi>
            <StyledFilter>
                <Label>
                    <Checkbox
                        checked={checked}
                        color={COLOR.PRIMARY}
                        handleChange={updateFilters}
                        name={name}
                    />
                    <Text>{name}</Text>
                </Label>
                {code && <Icon code={code} color={COLOR.PRIMARY} />}
            </StyledFilter>
        </StyledLi>
    )
}

const Label = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    ${Text} {
        margin-left: 10px;
    }
`

const StyledFilter = styled.label`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    cursor: pointer;
`
const StyledLi = styled.li`
    width: 100%;
    padding: 8px 0;
    list-style: none;
`
